import { Sparkle } from "lucide-react";
import { MARQUEE_ITEMS } from "../data/content";

// 6 copies : chaque moitié (3 copies) dépasse toujours la largeur de l'écran → aucun trou, boucle invisible.
const COPIES = [0, 1, 2, 3, 4, 5];

export const Marquee = () => (
  <div className="marquee-mask overflow-hidden border-y border-white/10 bg-[#1D1327] py-6" data-testid="marquee">
    <div className="marquee-track">
      {COPIES.map((track) => (
        <div key={track} aria-hidden={track > 0} className="flex shrink-0 items-center">
          {MARQUEE_ITEMS.map((item) => (
            <span key={item} className="flex items-center">
              <span className="whitespace-nowrap px-8 font-serif text-2xl text-white/65 sm:px-10 sm:text-3xl">{item}</span>
              <Sparkle className="h-3 w-3 shrink-0 text-neon" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
